import { fb } from '../../../form';

export function getShippingFormData(cart) {
  
  const data = cart || {};  
  var checkOnlyDelivery = false;
  
  for(var i in data.orderItems){

    if(data.orderItems[i].shippingFeeType === 99){
      checkOnlyDelivery = true;
      data.useSameAddress = false;
      break;
    }
  }

  // const shippingMethods = [
  //   { name: 'Shipping', value: "Standard" },
  //   { name: 'Pickup', value: "Pickup" }
  // ];

  const shippingMethods = checkOnlyDelivery ?
    [{ name: 'Pickup', value: "Pickup" }] :
    [{ name: 'Shipping', value: "Standard" }, { name: 'Collect in Store', value: "Pickup" }];
  
  const shippingCountry = [
    { name: 'Australia', value: "Australia" },
    { name: 'International', value: "International" }
  ];

  const countries = [
    { name: 'Select Country', value: "" },
    { name: 'United states', value: "United states" },
    { name: 'United states2', value: "United states2" }
  ];

  const model = fb.group({
    billingInfo: address(data.billingAddress),
    shippingInfo: address(data.shippingAddress),
    //shippingMethod: [data.shippingMethod || checkOnlyDelivery ? "Pickup" : "", [], { label: null, type: 'radioList', options : shippingMethods, style : {inline : true} }],
    shippingMethod: [data.shippingMethod || "", [], { label: null, type: 'radioList', options : shippingMethods, style : {inline : true} }],
    shippingCountry: [data.countries || '', [], { label: null, type: 'select', options : countries }],
    shippingCountryOption: [data.shippingCountry || '', [], { label: null, type: 'radioList', options : shippingCountry, style : {inline : true} }],
    useSameAddress: [data.useSameAddress || false, [], { label: `Use the same address`, type: 'checkbox' }],
    usePayWithAfterPay: [data.usePayWithAfterPay || false, [], { label: `Pay Interest Free With Afterpay`, type: 'checkbox' }]
  });
  return model;
}

export function address(model) {
  const data = model || {}
  return fb.group({
    firstName: [data.firstName || '', [], { label: 'First Name', type: 'text' }],
    surname: [data.surname || '', [], { label: 'Surname', type: 'text' }],
    street1: [data.street1 || '', [], { label: 'Street', type: 'text' }],
    street2: [data.street2 || '', [], { label: null, type: 'text' }],
    suburb: [data.suburb || '', [], { label: 'Suburb', type: 'text' }],
    state: [data.state || '', [], { label: 'State', type: 'text' }],
    postcode: [data.postcode || '', [], { label: 'Postcode', type: 'text' }],
    email: [data.email || '', [], { label: 'Email Address', type: 'email' }],
    mobile: [data.mobile || '', [], { label: 'Mobile', type: 'tel' }],
  })
}

// public AddressModel ShippingInfo { get; set; }
// public AddressModel BillingInfo { get; set; }
// public string ShippingMethod { get; set; }
// public bool UseSameAddress { get; set; }
// public string SpecialRequest { get; set; }

// public string FirstName { get; set; }
// public string Surname { get; set; }
// public string AddressLine { get; set; }
// public string Suburb { get; set; }
// public string State { get; set; }
// public string Postcode { get; set; }
// public string Country { get; set; }
// public string CountryCode { get; set; }
// public string Email { get; set; }
// public string Phone { get; set; }
// public string Mobile { get; set; }